var map = {
	"./01-01.mp3": 492,
	"./01-01__.mp3": 765,
	"./01-02.mp3": 766,
	"./01-03.mp3": 359,
	"./01-04.mp3": 360,
	"./01-05.mp3": 493,
	"./01-06.mp3": 767,
	"./01-07.mp3": 768,
	"./01-08.mp3": 769,
	"./01-09.mp3": 770,
	"./01-10.mp3": 771,
	"./01-11.mp3": 809,
	"./01-12.mp3": 1533,
	"./01-13.mp3": 1534,
	"./01-14.mp3": 810,
	"./04-01.mp3": 1535,
	"./04-02.mp3": 1536,
	"./04-03.mp3": 811,
	"./04.mp3": 1537,
	"./emotion-slow.mp3": 812,
	"./emotion.mp3": 1538,
	"./ex1-slow.mp3": 813,
	"./ex1.mp3": 1539,
	"./ex1_3_4-slow.mp3": 814,
	"./ex1_3_4.mp3": 1540,
	"./ex7-slow.mp3": 815,
	"./ex7.mp3": 1541,
	"./ex8-slow.mp3": 816,
	"./ex8.mp3": 1542,
	"./health-slow.mp3": 817,
	"./health.mp3": 1543,
	"./intoSleep.mp3": 501,
	"./life-cycle-slow.mp3": 818,
	"./life-cycle.mp3": 1544,
	"./life-slow.mp3": 819,
	"./life.mp3": 1545,
	"./natureFeedback.mp3": 1546,
	"./natureFeedbackEffect.mp3": 820,
	"./recognition-slow.mp3": 821,
	"./recognition.mp3": 1547,
	"./soundAlpha.mp3": 1548,
	"./soundAlpha1.mp3": 1549,
	"./soundAlpha2.mp3": 1550,
	"./soundAttemption.mp3": 772,
	"./soundAttemptionNew.mp3": 1551,
	"./soundBalance.mp3": 774,
	"./soundBalanceF.mp3": 1552,
	"./soundBalanceNew.mp3": 1553,
	"./soundConst.mp3": 773,
	"./soundConstNew.mp3": 1554,
	"./soundRest.mp3": 361,
	"./soundRestNew.mp3": 1555,
	"./view5-ex1-slow.mp3": 822,
	"./view8-ex1-slow.mp3": 823,
	"./view9-ex1-slow.mp3": 824
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1532;